"use strict";

exports.__esModule = true;
exports.default = isBoolean;
var _setup = require("./_setup.js");
// Is a given value a boolean?
function isBoolean(obj) {
  return obj === true || obj === false || _setup.toString.call(obj) === '[object Boolean]';
}